import axios from "axios";
import { getToken } from "./authStore";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

API.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getCategories = (companyId, typeId) =>
  API.get(`/settings/categories/active/${companyId}/${typeId}`);

export const getTypes = (companyId) =>
  API.get(`/settings/types/active/${companyId}`);

export const getStatus = (companyId) =>
  API.get(`/settings/status/active/${companyId}`);

export const getTickets = (params) => API.get(`/tickets/`, { params });

export default API;
